module.exports = __webpack_public_path__ + "img/send.60a25f0b.svg";